import { useState } from "react";
import type { ServerFile } from "../../types/ServerFile";
import { humanFileSize, toBase64 } from "../../tools/utils";
import  ImageIcon  from "./ImageIcon";

import { useTrads } from "../../contexts/trads/useTrads";

interface Props {
  value: ServerFile | undefined
  name: string
  onChange: (value: ServerFile|undefined) => void
  onBlur?: () => void
  disabled?: boolean
}


function AttachmentsSelector({ value, name, onChange, onBlur, disabled }: Props){
    const [file,setFile]=useState<ServerFile|undefined>(value);

    const handleChange = async (event:React.ChangeEvent<HTMLInputElement >) => {
        if(event.target.files){
            for (const file of event.target.files) {
                const f:ServerFile ={filename:"",filedata:"",mimetype:"",filesize:0}
                f.filename=file.name
                f.filedata = await toBase64(file);
                f.mimetype=file.type;
                f.filesize=file.size;
                addFile(f);
            }
            if(event.target.parentNode){
                event.target.value='';
                event.target.type='text';
                event.target.type='file';

            }
        }
    }

    function addFile(file:ServerFile){
        const newfile=file;
        setFile(newfile);
        onChange(newfile);
    }
    function removeFile(){ 
        
        setFile({filename:""});
        onChange({filename:""});
        
    }
    const {translate}=useTrads();


    return (
        
        <ul onBlur={onBlur} data-name={name} data-disbled={disabled}>
        
         {file?.filename?
            <li  >
                <ImageIcon mimetype={file.mimetype} /> 
                {file.mimetype?.startsWith('image/')?
                <img alt="" src={file.filename} width={file.size?.w} height={file.size?.h}/>
                :<span>{file.filename}</span>
                }
                 {file.filesize ?<small>{humanFileSize(file.filesize)}</small>:null}

                <button type="button" className="btn btn-danger" onClick={()=>{removeFile();}} title="supprimer" ><i className="bi bi-trash"></i></button> 
            </li>
        :
        <li >
            <label className="form-label"> {translate('attachment_add')}
            <input className="form-control" name={name} type="file" onChange={(e)=> void handleChange(e)} />
            </label>
        </li>
        }
        </ul>
    );
}
export default AttachmentsSelector;